import { createIcon } from '../createIcon';
import { ReactComponent as IconPlusCircle } from '../svg/plus-circle.svg';

export default createIcon(IconPlusCircle);
